<template lang="pug">
  .comments.column
    .row.end.m-bottom-1
      button.resolve.row.middle.center.m-left-1(v-if='commentsThread.length' :title='$t("krea.kreaActions.resolveThread")')
        simple-svg(:filepath='checkIcon' width='18px' height='18px')
    .container.kimple-scroll(v-if='commentsThread.length')
      .comment(v-for='comment in commentsThread')
        h2.text-normal.bold.m4-bottom-2 {{ comment.name }}
        h3.text-small {{ comment.body }}
    .container.empty.row.center.middle(v-else)
      h2.title-small.gray {{ $t("krea.kreaActions.emptyComments") }}
    .width-100.row.middle.center.m-top-1
      input.input-base.input-border(
        :placeholder='commentsThread.length ? $t("krea.kreaActions.commentPlaceholder") : $t("krea.kreaActions.emptyCommentsPlaceholder")'
      )
      button.submit.row.middle.center.m-left-1
        simple-svg.white-icon(:filepath='arrowUp' width='20px' height='20px')
</template>

<script>
import arrowUp from '@/assets/ic_chevron-up.svg'
import checkIcon from '@/assets/ic_check_base.svg'

export default {
  props: {
    commentsThread: { type: Array }
  },
  data() {
    return {
      arrowUp,
      checkIcon
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.comments{
  width: 350px;
  min-height: 150px;
  max-height: 550px;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid $black;
  background-color: $white;
  .container{
    padding-right: 5px;
    overflow-y: auto;
    &.empty{
      padding: 30px 0;
    }
    &>:not(:last-child){
      margin-bottom: 5px;
      padding-bottom: 10px;
      border-bottom: 1px solid $gray;
    }
  }
}

.input-base{
  margin: 0;
}

.resolve{
  border-radius: 5px;
  padding: 5px;
  &:hover{
    background-color: $light-gray;
  }
}

.submit{
  border-radius: 50%;
  padding: 5px;
  background-color: $dark-gray;
}
</style>
